import type { Features } from '../../hooks/use-features'

export interface SettingsTab {
  readonly key: string
  readonly label: string
  readonly featureFlag?: keyof Features
}

export interface TabGroup {
  readonly header: string
  readonly tabs: readonly SettingsTab[]
}

// Pure data, shared by SettingsPage (tab bar) and the sidebar quick-jump
// index (Layout). Keeping one source prevents the quick-jump entries from
// drifting when tabs are added or re-flagged.
export const TAB_GROUPS: readonly TabGroup[] = [
  {
    header: 'People',
    tabs: [
      { key: 'providers', label: 'Providers' },
      { key: 'ehr', label: 'EHR Configs', featureFlag: 'ehr' },
      { key: 'clients', label: 'Clients' },
      { key: 'users', label: 'Users' },
    ],
  },
  {
    header: 'Tests & Panels',
    tabs: [
      { key: 'test-types', label: 'Test Types' },
      { key: 'panel-management', label: 'Panels' },
      { key: 'panel-dictionary', label: 'Panel Dictionary' },
      { key: 'reference-lab', label: 'Reference Lab' },
    ],
  },
  {
    header: 'Billing',
    tabs: [
      { key: 'payers', label: 'Payers' },
      { key: 'diagnosis-codes', label: 'Diagnosis Codes' },
      { key: 'procedure-codes', label: 'Procedure Codes' },
    ],
  },
  {
    header: 'Printing',
    tabs: [
      { key: 'printers', label: 'Printers' },
      { key: 'label-templates', label: 'Label Templates' },
    ],
  },
  {
    header: 'System',
    tabs: [
      { key: 'org', label: 'Organization' },
      { key: 'license', label: 'License' },
      { key: 'system', label: 'System Status' },
      { key: 'media', label: 'Media' },
      { key: 'clinical-trial', label: 'Clinical Trial' },
      { key: 'logging', label: 'Logging' },
      { key: 'updates', label: 'Updates' },
      { key: 'migration', label: 'Migration', featureFlag: 'migration' },
      { key: 'demo', label: 'Demo', featureFlag: 'demo' },
      { key: 'cdph', label: 'CDPH Reporting' },
      { key: 'cdph-reports', label: 'CDPH Report Queue' },
    ],
  },
]
